import React, { Component } from 'preact';
import { Link, route } from 'preact-router';
import VisibiltySensor from 'react-visibility-sensor';
import _, { debounce } from 'lodash';

import { API } from '../../../components/API/index.js';
import HeaderButton from './headerButton';
import { checkForIos } from '../../../utils/checkForIos';

import style from './search.scss';

class Search extends Component {
	constructor(props) {
		super(props);

		this.state = {
			currentPage        : 1,
			noValue            : false,
			resultCount        : 'SEARCH',
			searchValue        : '',
			searchData         : [],
			searchResultCount  : 20,
			searchCompleteData : [],
			noData             : false,
			apiCall            : false
		};

		this.inputRef = React.createRef();

		this.getInputFocus = this.getInputFocus.bind(this);
		this.handleFocus = this.handleFocus.bind(this);
		this.handleFocusOut = this.handleFocusOut.bind(this);
		this.renderHeader = this.renderHeader.bind(this);
		this.renderSearchInputBox = this.renderSearchInputBox.bind(this);
	}

	componentWillUnmount() {
		this.inputRef.current.value = null;
	}

	fetchPaginatedData = (isVisible) => {
		let { currentPage, searchCompleteData, searchResultCount, resultCount } = this.state;
		if (isVisible && parseInt(resultCount.split(' ')[0]) > (parseInt(currentPage) - 1) * searchResultCount) {
			this.setState({
				currentPage : parseInt(currentPage) + 1,
				searchData  : searchCompleteData.slice(0, currentPage * searchResultCount)
				// apiCall: false
			});
		}
	};

	getInputFocus() {
		let { noValue } = this.state;

		!noValue && this.inputRef.current.focus();
	}

	handleFocus(e) {
		if (e.target.value.length <= 0)
			this.setState({
				noValue : true,
				noData  : false
			});
	}

	handleFocusOut(e) {
		if (e.target.value.length <= 0)
			this.setState({
				currentPage     : 1,
				currentSelected : 1,
				noValue         : false,
				noData          : false,
				searchData      : [],
				searchValue     : '',
				resultCount     : 'SEARCH'
			});
	}

	renderLogo() {
		return (
			<Link
				onClick={() => {
					document.location.replace('/');
				}}
			>
				<img style="cursor:pointer" src={`/assets/logos/blueconnect.png`} />
			</Link>
		);
	}

	renderHeader() {
		let { handleSearchModel } = this.props;

		return (
			<header className={style.searchHeader} id="search-header">
				<div>{this.renderLogo()}</div>
				<img
					class={style.searchClose}
					src="/assets/images/searchclose.png"
					onClick={() => {
						handleSearchModel();
					}}
				/>
			</header>
		);
	}

	renderSearchInputBox() {
		let { noValue, resultCount, searchData } = this.state;

		return (
			<div
				className={[
					style.searchBoxWrapper,
					searchData.length ? style.moveSearchToTop : ''
				].join(' ')}
			>
				<span className={noValue ? style.noValue : ''} onClick={this.getInputFocus}>
					{resultCount}
				</span>
				<input
					spellcheck="false"
					id="search-box"
					type="text"
					maxlength="50"
					autocomplete="off"
					ref={this.inputRef}
					onKeyUp={this.searchHandler}
					onFocus={this.handleFocus}
					onFocusOut={this.handleFocusOut}
				/>
				<input type="submit" style={{ position: 'absolute', left: '-100000' }} />
			</div>
		);
	}

	renderType(item) {
		if (item.field_code === 'COMPANY') {
			return item.field_code.toUpperCase();
		}
		else if (item.field_code === 'STORIES') {
			return item.field_article === 'True' ? 'ARTICLE' : 'COVERAGE';
		}
		else if (item.field_code === 'CONNECT') {
			return item.field_insight === 'True' ? 'INSIGHT' : 'COLLABS';
		}
	}

	renderTitle(item) {
		const parser = new DOMParser();
		if (item.field_code === 'COMPANY') {
			const decodedDescription = parser.parseFromString(
				`<!doctype html><body>${item.field_company_names}`,
				'text/html'
			).body.textContent;
			return decodedDescription;
		}
		else if (item.field_code === 'STORIES') {
			const decodedDescription = parser.parseFromString(
				`<!doctype html><body>${item.field_news_heading}`,
				'text/html'
			).body.textContent;
			return decodedDescription;
		}
		else if (item.field_code === 'CONNECT') {
			const decodedDescription = parser.parseFromString(
				`<!doctype html><body>${item.field_article_heading}`,
				'text/html'
			).body.textContent;
			return decodedDescription;
		}
	}

	renderSearchResultList() {
		let { searchData, noData, apiCall } = this.state;

		if (apiCall === true) {
			return (
				<div
					style="justify-content:center;object-fit:cover;width:7rem;height:7rem"
					className={style.searchResultWrapper}
				>
					<img style="width:100%;height:100%" src="/assets/preload.gif" />
				</div>
			);
		}

		if (!searchData.length && !noData) return null;

		if (noData === true) {
			return (
				<div className={style.searchResultWrapper}>
					<div className={style.searchNoDataWrapper}>RESULT NOT FOUND</div>
				</div>
			);
		}

		return (
			<div className={style.searchResultWrapper}>
				{searchData.map((item) => (
					<div
						className={style.searchItemWrapper}
						onClick={() => {
							const parser = new DOMParser();
							if (item.field_code === 'STORIES') {
								window.open(
									'http://venture.dev365.gdpventure.com/#/story/' + item.field_news,
									'_blank'
								);
							}
							else if (item.field_code === 'COMPANY') {
								window.open(
									'http://venture.dev365.gdpventure.com/#/company/' + item.field_company_slug,
									'_blank'
								);
							}
							else if (item.field_code === 'CONNECT') {
								route('/article?title=' + item.field_url);
							}
						}}
					>
						<span className={style.searchItemTitle}>{this.renderType(item)}</span>
						<span className={style.searchItemDescription}>{this.renderTitle(item)}</span>
					</div>
				))}
				<VisibiltySensor
					onChange={(event) => {
						this.fetchPaginatedData(event);
					}}
					active={true}
					// offset={{ top: 10 }}
				>
					<div style="color:white;font-size:0.1rem">..</div>
				</VisibiltySensor>
			</div>
		);
	}

	searchHandler = (e) => {
		const ref = this;

		e.persist();

		if (!this.debouncedFn) {
			this.debouncedFn = _.debounce(() => {
				var searchKeyword = e.target.value.trim();
				var searchKeyWordCount = searchKeyword.split(' ').length;
				ref.setState({
					noData : false
				});
				if (searchKeyword.length > 2 && searchKeyWordCount <= 5) {
					// document.activeElement.blur();
					document.getElementById('search-box').blur();
					ref.setState({
						apiCall : true
					});
					API.getPOSTData('venture/universalSearch', {
						term : searchKeyword
					}).then((res) => {
						res = res.DATA;
						ref.setState({
							apiCall : false
						});
						if (res.length === 0) {
							ref.setState({
								noData : true
							});
						}
						ref.setState({
							searchCompleteData : res && e.target.value ? res : [],
							searchData         :
								res && e.target.value
									? res.slice(0, this.state.searchResultCount * this.state.currentPage)
									: [],
							searchValue        : searchKeyword,
							resultCount        : res.length && e.target.value ? `${res.length} results` : 'SEARCH',
							currentPage        : parseInt(this.state.currentPage) + 1
						});
					});
				}
			}, 1000);
		}
		this.debouncedFn();
		e.preventDefault();
	};

	render() {
		return (
			<section className={style.searchWrapper}>
				{this.renderHeader()}
				<main id="search-container" className={style.searchContainer}>
					{this.renderSearchInputBox()}
					{this.renderSearchResultList()}
				</main>
			</section>
		);
	}
}

export default Search;



// WEBPACK FOOTER //
// ./components/header/components/search.js